import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';

import { CollapsibleSearchInputComponent } from '@ui-components/components/collapsible-search-input/collapsible-search-input.component';

import { RadioButtonBottomSheetComponent } from './radio-button-bottom-sheet.component';

@NgModule({
  declarations: [RadioButtonBottomSheetComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    CollapsibleSearchInputComponent,
  ],
  exports: [RadioButtonBottomSheetComponent],
})
export class RadioButtonBottomSheetModule {}
